export const UKGC_DIALOG = 'ukgcDialog';
export const REGULATIONS_DIALOG = 'regulationsDialog';
